export default __webpack_public_path__ + "static/media/library-empty.a673fcbe.jpg";